import * as React from 'react';
import { MainMenu, MainMenuLeafItem, MainMenuGroupItem } from './MainMenu';
import { Link } from 'components/link/Link';
import { LeafMenuItemComponent } from './LeafMenuItemComponent';
import { GroupMenuItemComponent } from './GroupMenuItemComponent';
import { Meta } from 'utils/meta';

export class MainMenuComponent extends React.Component<MainMenuComponentProps, MainMenuComponentState> {

    public render() {
        return (
            <div style={{position: 'fixed', width: '300px', left: '0px', top: '0px', bottom: '0px', backgroundColor: '#2f3c4f', boxShadow: '1px 1px 10px rgba(0,0,0,0.5)'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', height: '100%'}}>
                    <div style={{marginTop: '40px', width: '64px', height: '64px', border: '5px solid rgba(255,255,255,1.0)', backgroundImage: "url('/ProfilePicture?uid=" + Meta.get().userId + "')", backgroundSize: 'cover', borderRadius: '50%'}}></div>
                    
                    <div title={Meta.get().email} style={{display: 'inline-block', fontSize: '18px', fontWeight: 600, color: 'rgba(255,255,255, 0.8)', paddingTop: '10px'}}>
                        {Meta.get().userName}
                    </div>
                    <div style={{display: 'inline-block', fontSize: '14px', fontWeight: 400, color: 'rgba(255,255,255, 0.4)', paddingTop: '3px'}}>
                        {Meta.get().companyName}
                    </div>

                    <div style={{height: '40px'}}></div>

                    {MainMenu.topItems.map((item) => {
                        if (item instanceof MainMenuLeafItem) {
                            return (<LeafMenuItemComponent key={"leaf-" + item.url} currentUrl={this.props.currentUrl} item={item} />);
                        } else if (item instanceof MainMenuGroupItem) {
                            return (<GroupMenuItemComponent  key={"group-" + item.title} currentUrl={this.props.currentUrl} item={item} />)
                        } else {
                            throw new Error('Invalid main menu item type: ' + item);
                        }
                    })}

                    <div style={{display: 'flex', flexDirection: 'column', flexGrow: 1, alignItems: 'flex-start', justifyContent: 'flex-end', width: '100%', paddingBottom: '40px'}}>
                    {MainMenu.bottomItems.map((item) => {
                        if (item instanceof MainMenuLeafItem) {
                            return (<LeafMenuItemComponent key={"leaf-" + item.url} currentUrl={this.props.currentUrl} item={item} />);
                        } else if (item instanceof MainMenuGroupItem) {
                            return (<GroupMenuItemComponent key={"group-" + item.title} currentUrl={this.props.currentUrl} item={item} />)
                        } else {
                            throw new Error('Invalid main menu item type: ' + item);
                        }
                    })}
                    </div>

                </div>
            </div>
        );
    }

}

export class MainMenuComponentProps {

    public currentUrl: string;

}

export class MainMenuComponentState {

}



